import React from 'react';
import { func, node, object, shape, string } from 'prop-types';
import classNames from 'classnames';
import { TwitterTweetEmbed } from 'react-twitter-embed';
import Field, { hasDataInFields } from '../../Field';
import BlockContainer from '../BlockContainer';
import { CookieBlockedIframe } from '../../../../components';

import css from './BlockDefault.module.css';

const FieldMedia = props => {
  const { className, media, sizes, options, portrait } = props;
  const hasMediaField = hasDataInFields([media], options);
  return hasMediaField ? (
    <div
      className={
        portrait ? classNames(className, css.media, css.portrait) : classNames(className, css.media)
      }
    >
      <Field data={media} sizes={sizes} options={options} />
    </div>
  ) : null;
};

const BlockDefault = props => {
  const {
    blockId,
    className,
    rootClassName,
    mediaClassName,
    textClassName,
    ctaButtonClass,
    title,
    text,
    callToAction,
    media,
    responsiveImageSizes,
    options,
  } = props;
  const portrait = blockId == 'portrait';
  let classes = classNames(rootClassName || css.root, className);
  const hasTextComponentFields = hasDataInFields([title, text, callToAction], options);
  const regEx = /(?<=^\[(.*?)\])\((.*?)\)/;
  const wholeLinkReg = /(^\[(.*?)\])\((\/p.*?)\)/;
  //const iframeReg = /(iframe)-(.*?)-/;
  // markdown token: iframe-<URL>-
  const iframeReg = /(iframe)-\s*(.+?)\s*-/;
  const url = text.content && regEx.exec(text.content);
  const authorReg = /(.*)min read/;
  const byline = text.content && text.content.match(authorReg);
  const wholeLink = text.content && wholeLinkReg.exec(text.content);
  const iframe = text.content && iframeReg.exec(text.content);
  const iframeURL = iframe?.[2];
  const isGitBook =
    !!iframeURL &&
    /^(https?:\/\/)?(organisation\.signalise\.coop|[\w.-]+\.gitbook\.(io|com))/.test(iframeURL);
  const link = url?.[2];
  const replaceLink = wholeLink && {
    content: text.content.replace(wholeLinkReg, wholeLink?.[2]),
    fieldType: 'markdown',
  };
  const replaceByline = wholeLink &&
    byline && {
      content: replaceLink.content.replace(byline[0], ''),
      fieldType: 'markdown',
    };
  const tweetRegEx = /((?<=(tweet|twitter):)[\d]+)/;
  const tweetSearch = text && tweetRegEx.exec(text.content);
  const tweetID = tweetSearch?.[0];
  const blockContainer = (
  <BlockContainer
      id={blockId}
      className={
        iframeURL 
          ? classNames(
              classes, 
              css.iframeRoot,
              isGitBook && css.iframeRootGitBook // modifier for GitBook iframes
            ) : classes}          
    >
      {iframeURL ? (
          <CookieBlockedIframe
            src={iframeURL}  // Add the src prop
            className={classNames(css.iframe, isGitBook && css.iframeGitBook)}
            width="100%"
            height="100%"
            style={{ position: 'absolute', top: 0, left: 0 }}
          />
      ) : (
        <FieldMedia
          media={media}
          sizes={responsiveImageSizes}
          className={mediaClassName}
          options={options}
          portrait={portrait}
        />
      )}

      {hasTextComponentFields && (
        <div className={classNames(textClassName, css.text)}>
          <Field data={title} options={options} />

          {tweetID ? (
            <TwitterTweetEmbed tweetId={tweetID} />
          ) : !iframeURL ? (
            <div>
              <Field
                data={url ? (byline ? replaceByline : replaceLink) : text}
                options={options}
              />
            </div>
          ) : null}

          <Field data={callToAction} className={ctaButtonClass} options={options} />
        </div>
      )}
    </BlockContainer>
  );

  return link ? (
    <div>
      <a href={link}>{blockContainer}</a>
      {byline && <p>{byline[0]}</p>}
    </div>
  ) : (
    blockContainer
  );
};

const propTypeOption = shape({
  fieldComponents: shape({ component: node, pickValidProps: func }),
});

BlockDefault.propTypes = {
  blockId: string.isRequired,
  className: string,
  rootClassName: string,
  mediaClassName: string,
  textClassName: string,
  ctaButtonClass: string,
  title: object,
  text: object,
  callToAction: object,
  media: object,
  responsiveImageSizes: string,
  options: propTypeOption,
};

export default BlockDefault;
